import React from "react";
import { Route, Routes } from "react-router-dom";

import { Dashboard as Home } from "./pages/Dashboard";
import NotFound from "./pages/NotFound";

type Props = {
  onRouteNotFound?: () => void;
};

export default class Dashboard extends React.Component<Props> {
  render() {
    const { onRouteNotFound } = this.props;
    return (
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="" element={<Home />} />
        <Route element={<NotFound onRouteNotFound={onRouteNotFound} />} />
      </Routes>
    );
  }
}
